import React from "react";
// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Chat from "@material-ui/icons/Chat";
import Contacts from "@material-ui/icons/Contacts";
import Assignment from "@material-ui/icons/Assignment";
import Subject from "@material-ui/icons/Subject";
import OportunityIcon from '@material-ui/icons/WbIncandescent';
import DealIcon from "@material-ui/icons/BusinessCenter";
// core components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";

import ContactData from './ContactData.jsx'
import ContactTrack from './ContactTrack.jsx'
import ContactsTab from './ContactsTab.jsx'
import NotesTab from './NotesTab.jsx'
import TasksTab from './TasksTab.jsx'
import OportunitiesTab from './OportunitiesTab.jsx'
import DealsTab from './DealsTab.jsx'

const styles = {
  textCenter: {
    textAlign: "center"
  },
  avatar: {
    width: '200px',
    height: '200px'
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
    marginBottom: "50px"
  }
};

class ContactTabs extends React.Component{
  render(){
    const { classes } = this.props;
    const { profile } = this.props;
    return (
      <div>
      <CustomTabs
        plainTabs
        headerColor="info"
        tabs={[
          {
            tabName: "Profile",
            tabIcon: Face,
            tabContent: (
                  <ContactData profile={profile} />
            )
          },
          {
            tabName: "Contacts",
            tabIcon: Contacts,
            tabContent: (
                <ContactsTab profile={profile} />

            )
          },
          {
            tabName: "Tasks",
            tabIcon: Assignment,
            tabContent: (
                  <TasksTab profile={profile} />
            )
          },
          {
            tabName: "Notes",
            tabIcon: Subject,
            tabContent: (
                  <NotesTab profile={profile} />
            )
          },
          {
            tabName: "Oportunities",
            tabIcon: OportunityIcon,
            tabContent: (
                  <OportunitiesTab profile={profile} />
            )
          },
          {
            tabName: "Deals",
            tabIcon: DealIcon,
            tabContent: (
                  <DealsTab profile={profile} />
            )
          }
        ]}
      />
      </div>
    );
  }
}

export default withStyles(styles)(ContactTabs);
